export var IntervalUnit;
(function (IntervalUnit) {
    /** unknown interval unit */
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    /** day */
    IntervalUnit["DAY"] = "DAY";
    /** week */
    IntervalUnit["WEEK"] = "WEEK";
    /** month */
    IntervalUnit["MONTH"] = "MONTH";
    /** year */
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit || (IntervalUnit = {}));
/** Determines the reset cycle of the feature usage. */
export var FeaturePeriod;
(function (FeaturePeriod) {
    FeaturePeriod["NO_PERIOD"] = "NO_PERIOD";
    FeaturePeriod["MILLISECOND"] = "MILLISECOND";
    FeaturePeriod["SECOND"] = "SECOND";
    FeaturePeriod["MINUTE"] = "MINUTE";
    FeaturePeriod["HOUR"] = "HOUR";
    FeaturePeriod["DAY"] = "DAY";
    FeaturePeriod["WEEK"] = "WEEK";
    FeaturePeriod["MONTH"] = "MONTH";
    FeaturePeriod["YEAR"] = "YEAR";
})(FeaturePeriod || (FeaturePeriod = {}));
export var DurationUnit;
(function (DurationUnit) {
    /** unknown interval unit */
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    /** day */
    DurationUnit["DAY"] = "DAY";
    /** week */
    DurationUnit["WEEK"] = "WEEK";
    /** month */
    DurationUnit["MONTH"] = "MONTH";
    /** year */
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));
export var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType || (CycleType = {}));
export var PurchaseScenario;
(function (PurchaseScenario) {
    /** user not authorized to purchase in the given account */
    PurchaseScenario["UNAUTHORIZED"] = "UNAUTHORIZED";
    /** account level purchase */
    PurchaseScenario["ACCOUNT_LEVEL"] = "ACCOUNT_LEVEL";
    /** site level purchase */
    PurchaseScenario["PURCHASE"] = "PURCHASE";
    /** user is permitted to view offering, but not purchase */
    PurchaseScenario["VIEW"] = "VIEW";
    /** no products available for purchase - this can happen when there are no products in the given offering, or when there is a current subscription, with no upgrade path */
    PurchaseScenario["EMPTY_OFFERING"] = "EMPTY_OFFERING";
    /** no logged in user */
    PurchaseScenario["ANONYMOUS"] = "ANONYMOUS";
})(PurchaseScenario || (PurchaseScenario = {}));
export var TaxType;
(function (TaxType) {
    TaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxType["REGULAR"] = "REGULAR";
    TaxType["EU_VAT"] = "EU_VAT";
    TaxType["JAPAN_JCT"] = "JAPAN_JCT";
    TaxType["AU_GST"] = "AU_GST";
    TaxType["BR_CNPJ"] = "BR_CNPJ";
    TaxType["RU_TIN"] = "RU_TIN";
    TaxType["IN_RNR"] = "IN_RNR";
    TaxType["IL_VAT"] = "IL_VAT";
    TaxType["US_TAX"] = "US_TAX";
    TaxType["SG_GST"] = "SG_GST";
    TaxType["CA_GST"] = "CA_GST";
    TaxType["CA_HST"] = "CA_HST";
    TaxType["CA_PST"] = "CA_PST";
    TaxType["CA_QST"] = "CA_QST";
    TaxType["NZ_GST"] = "NZ_GST";
    TaxType["MD_VAT"] = "MD_VAT";
    TaxType["CL_VAT"] = "CL_VAT";
    TaxType["MY_VAT"] = "MY_VAT";
    TaxType["KR_VAT"] = "KR_VAT";
    TaxType["TW_VAT"] = "TW_VAT";
    TaxType["AE_VAT"] = "AE_VAT";
    TaxType["NG_VAT"] = "NG_VAT";
    TaxType["IS_VAT"] = "IS_VAT";
    TaxType["GE_VAT"] = "GE_VAT";
    TaxType["TH_VAT"] = "TH_VAT";
    TaxType["TR_VAT"] = "TR_VAT";
    TaxType["NO_VAT"] = "NO_VAT";
    TaxType["UA_VAT"] = "UA_VAT";
    TaxType["IN_GST"] = "IN_GST";
    TaxType["KZ_VAT"] = "KZ_VAT";
    TaxType["TZ_VAT"] = "TZ_VAT";
})(TaxType || (TaxType = {}));
export var TaxSettingsTaxType;
(function (TaxSettingsTaxType) {
    TaxSettingsTaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxSettingsTaxType["VAT"] = "VAT";
    TaxSettingsTaxType["GST"] = "GST";
})(TaxSettingsTaxType || (TaxSettingsTaxType = {}));
export var FreeTrialIneligibilityReasonEnum;
(function (FreeTrialIneligibilityReasonEnum) {
    FreeTrialIneligibilityReasonEnum["UNKNOWN"] = "UNKNOWN";
    FreeTrialIneligibilityReasonEnum["ACCOUNT_NOT_ELIGIBLE"] = "ACCOUNT_NOT_ELIGIBLE";
    FreeTrialIneligibilityReasonEnum["NOT_INITIAL_PURCHASE"] = "NOT_INITIAL_PURCHASE";
    FreeTrialIneligibilityReasonEnum["NO_FREE_TRIAL_PRODUCT"] = "NO_FREE_TRIAL_PRODUCT";
})(FreeTrialIneligibilityReasonEnum || (FreeTrialIneligibilityReasonEnum = {}));
export var SubscriptionUpgradeType;
(function (SubscriptionUpgradeType) {
    SubscriptionUpgradeType["UNKNOWN"] = "UNKNOWN";
    /** unused subscription period is converted into credit deducted from the purchase price */
    SubscriptionUpgradeType["CREDIT_UNUSED_PERIOD"] = "CREDIT_UNUSED_PERIOD";
    /** add additional $CYCLE starting at subscription's end date */
    SubscriptionUpgradeType["EXTEND"] = "EXTEND";
})(SubscriptionUpgradeType || (SubscriptionUpgradeType = {}));
export var ContractSwitchType;
(function (ContractSwitchType) {
    ContractSwitchType["UNKNOWN"] = "UNKNOWN";
    /** unused subscription period is converted into credit deducted from the purchase price */
    ContractSwitchType["CREDIT_UNUSED_PERIOD"] = "CREDIT_UNUSED_PERIOD";
    /** add additional $CYCLE starting at subscription's end date - NOT READY YET */
    ContractSwitchType["EXTEND"] = "EXTEND";
    /** switch to new subscription immediately with no refund for unused period. */
    ContractSwitchType["FULL_AMOUNT_PERIOD"] = "FULL_AMOUNT_PERIOD";
    /** switch to lower subscription (plan or cycle) immediately. */
    ContractSwitchType["DOWNGRADE_RENEWAL"] = "DOWNGRADE_RENEWAL";
})(ContractSwitchType || (ContractSwitchType = {}));
export var ValidateNoPreviousPurchaseType;
(function (ValidateNoPreviousPurchaseType) {
    ValidateNoPreviousPurchaseType["UNKNOWN"] = "UNKNOWN";
    /** no pending order or delivery exist , valid purchase */
    ValidateNoPreviousPurchaseType["OK"] = "OK";
    /** there is open order without delivery , not valid purchase */
    ValidateNoPreviousPurchaseType["PENDING"] = "PENDING";
    /** purchase already delivered */
    ValidateNoPreviousPurchaseType["DELIVERED"] = "DELIVERED";
    /** failed to retrieve data from SBS */
    ValidateNoPreviousPurchaseType["SERVER_ERROR"] = "SERVER_ERROR";
})(ValidateNoPreviousPurchaseType || (ValidateNoPreviousPurchaseType = {}));
//# sourceMappingURL=types.impl.js.map